"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureGateEnvironment = void 0;
var FeatureGateEnvironment;
(function (FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
})(FeatureGateEnvironment || (exports.FeatureGateEnvironment = FeatureGateEnvironment = {}));
